import React, { useContext, useState, useEffect } from 'react';
import { Row, Col, Form, Tabs, Modal } from 'antd';
import {
  Button,
  Input,
  Layout,
  Select,
  Phone,
  MessageSteps,
  Footer,
} from 'components';

import MessagesSummary from '../messages-summary';

import ArrowRight from 'assests/icons/arrow-right';
import LetterIcon from 'assests/icons/letter.icon';
import AudienceIcon from 'assests/icons/audience.icon';
import ProfileIcon from 'assests/icons/profile.icon';
import ClockIcon from 'assests/icons/clock.icon';

import './steps.less';
import './choose-title.less';
import { DimensionsContext } from 'context/dimensions.context';
import classNames from 'classnames';
import { getActiveAlphaNumerics } from 'services/alpha.service';
import { customMessages } from 'utils';
import { useJob } from 'context/job.context';
import { useLocation } from 'react-router';

const { TabPane } = Tabs;

const ChooseTitle = (props) => {
  let location = useLocation();
  const { currentJob, setCurrentJob } = useJob();
  const { isPc } = useContext(DimensionsContext);
  const [form] = Form.useForm();
  const [titleList, setTitleList] = useState([]);
  const [valid, setValid] = useState(false);

  const [selectedTitle, setSelectedTitle] = useState(null);
  const [campaignName, setCampaignName] = useState(null);

  useEffect(() => {
    if (location.state?.messageData) {
      form.setFieldsValue({
        sender: location.state?.messageData?.sender,
        campaignName:location.state?.messageData?.campaignName
      });
      setCurrentJob({messageWithoutEtk:location.state?.messageData.messageText,...location.state?.messageData});
      setSelectedTitle(location.state?.messageData?.sender);
      setCampaignName(location.state?.messageData?.campaignName);
    }
  }, []);

  const onValuesChange = () => {
    setTimeout(() => {
      form
        .validateFields()
        .then((values) => {
          setValid(true);
        })
        .catch((errorInfo) => {
          setValid(false);
        });
    }, 10);
  };

  const onGetUserAlphas = () => {
    getActiveAlphaNumerics()
      .then((res) => {
        setTitleList(res.alphaNumerics);
      })
      .catch((response) => {
        Modal.error({
          title: 'Hata',
          content: customMessages.getMessage(response.responseCode),
        });
      });
  };

  const handleChange = (value) => {
    setSelectedTitle(value);
  };

  const onNext = () => {
    form.validateFields().then((values) => {
      setCurrentJob({ ...currentJob, ...values });
      props.updateCurrent(1);
    });
  };
  useEffect(() => {
    onGetUserAlphas();
    onValuesChange();
  }, []);

  return (
    <div className="choose-title-page">
      <Form
        form={form}
        onValuesChange={onValuesChange}
        name="choose-title"
      >
        <div
          className={classNames('step-transitions', {
            'padding-spaces-none': !isPc,
          })}
        >
          <div className="container">
            <div className="step-transitions_left"></div>
            {isPc ? (
              <div className="step-transitions__right">
                <Button
                  type="primary"
                  shape="round"
                  htmlType="submit"
                  className="ant-btn--icon"
                  onClick={onNext}
                  disabled={!valid}
                >
                  Mesajınızı Yazın
                  <ArrowRight />
                </Button>
              </div>
            ) : null}
          </div>
        </div>
        <div className="page-content">
          <div className="container">
            <Row className="message-preparing">
              <Col md={24} lg={24} xl={8} span={24}>
                <div className="message-preparing__left">
                  <div>
                    <h3 className="box__title">Ünvan Seçimi Yapın</h3>
                    <Form.Item
                      rules={[{ required: true }]}
                      initialValue={currentJob?.sender}
                      name="sender"
                    >
                      <Select
                        onChange={handleChange}
                        compClass="select--big"
                        label="Ünvanınız"
                        keyvalue="alphaNumericName"
                        labelvalue="alphaNumericName"
                        info={
                          <>
                            Onaylanan ünvanlarınız arasından dilediğinizi
                            seçebilirsiniz. <br /> Ünvanınız mesaj başlığı
                            olarak kullanılacaktır.
                          </>
                        }
                        data={titleList}
                        disabled={titleList.length == 0}
                      ></Select>
                    </Form.Item>
                    {/* {titleList.length == 0 ? (
                        <Button
                          type="primary"
                          shape="round"
                          className="ant-btn--icon margin-top-spacing-m"
                        >
                          Yeni Ünvan Tanımlayın
                          <ArrowRight />
                        </Button>
                      ) : (
                        false
                      )} */}
                  </div>
                  <div>
                    <h3 className="box__title">Rapor Adı Belirleyin</h3>
                    <Form.Item
                      initialValue={currentJob?.campaignName}
                      rules={[
                        {
                          required: true,
                          message: 'Please input your password!',
                        },
                      ]}
                      name="campaignName"
                    >
                      <Input
                        compClass="input--big"
                        type="text"
                        onChange={(e) => setCampaignName(e.target.value)}
                        label="Rapor Adı"
                        name="campaignName"
                        info={
                          <span>
                            Bu isim sadece raporlarınız oluşturulurken
                            kullanılacaktır, göndereceğiniz mesajda
                            kullanılmayacaktır
                          </span>
                        }
                      />
                    </Form.Item>
                  </div>
                </div>
              </Col>
              <Col
                s={24}
                md={{ span: 11 }}
                lg={{ span: 11 }}
                xl={{ span: 8, offset: 1 }}
                span={24}
              >
                <div className="message-preparing__center">
                  <Tabs defaultActiveKey="1">
                    <TabPane tab="Mesaj Detayı" key="1">
                      <Phone
                        time="05:32"
                        title={selectedTitle}
                        message={currentJob.messageText}
                      />
                    </TabPane>
                    <TabPane tab="Bildirim" key="2">
                      <Phone
                        lockScreen
                        title={selectedTitle}
                        message={currentJob.messageText}
                      />
                    </TabPane>
                  </Tabs>
                </div>
              </Col>
              <Col
                s={24}
                md={{ span: 11, offset: 2 }}
                lg={{ span: 11, offset: 2 }}
                xl={{ span: 6, offset: 1 }}
                span={24}
              >
                <div className="message-preparing__right">
                  <MessagesSummary
                    title={selectedTitle}
                    message={currentJob?.messageText}
                    receivers={currentJob?.receivers}
                    reportName={campaignName}
                  />
                </div>
              </Col>
            </Row>
          </div>
          {!isPc ? (
            <div className="step-transitions__right">
              <Button
                type="primary"
                shape="round"
                htmlType="submit"
                className="ant-btn--icon"
                onClick={onNext}
                disabled={!valid}
              >
                Mesajınızı Yazın
                <ArrowRight />
              </Button>
            </div>
          ) : null}
        </div>
      </Form>
    </div>
  );
};

export default ChooseTitle;
